import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { AvtDialogDeleteComponent } from 'src/app/avt-dialog-delete/avt-dialog-delete.component';
import { ListeComponent } from 'src/app/liste/liste.component';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';
import * as globalUrls from '../../services/globalVariables';

declare var $: any;
@Component({
  selector: 'app-grh-conge',
  templateUrl: './grh-conge.component.html',
  styleUrls: ['./grh-conge.component.scss'],
})
export class GrhCongeComponent implements OnInit {
  constructor(
    private generalService: GeneralService,
    private dateService: DateService
  ) {}
  exist: boolean = false;
  listeCongeNatureIsLoadet: boolean = false;
  listeCongerIsLoadet: boolean = false;
  listeCongeNature = [];
  listeConger = [];
  dsConger;
  conge;
  initDsConger;
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'CongeNature',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Conge_DateDebut',
        Lg_Code: '',
        TableRD_Des: 'Libellé',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: false,
        TableRD_Format: 'dd/MM/yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Conge_DateFin',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd/MM/yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Conge_NbrJour',
        Lg_Code: '',
        TableRD_Des: 'Libellé',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'CongeEtat1',
        Lg_Code: '',
        TableRD_Des: 'Libellé',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  @ViewChild('frmConge', { static: false }) frmConge;
  titre: string = '';
  disabled = false;
  date_Debut;
  date_Fin;
  nbrJourCongeRestant = '...';
  @ViewChild('listeCongeConmponent', { static: false })
  listeCongeConmponent: ListeComponent;
  ngOnInit(): void {
    this.date_Debut = new Date();
    this.date_Debut.setMonth(this.date_Debut.getMonth() - 1);
    this.date_Debut.setDate(1);
    this.date_Fin = new Date();
    this.date_Fin.setMonth(this.date_Fin.getMonth() + 1);
    this.date_Fin.setDate(
      this.dateService.getLastDayOfMonth(this.date_Fin.getMonth())
    );
    this.getCongeNature();
    this.getListeConger();
    this.getDsConger();
    this.getNbrJourCongeRestant();
  }
  getNbrJourCongeRestant() {
    if (this.generalService.collaborateurConnecter)
      this.generalService
        .rechercheTable(
          this.generalService.url +
            'soldeConge&param=' +
            this.generalService.collaborateurConnecter
        )
        .subscribe((data) => {
          this.nbrJourCongeRestant = data[0].solde + ' jour(s)';
        });
    else
      setTimeout(() => {
        this.getNbrJourCongeRestant();
      }, 100);
  }
  getDsConger() {
    this.generalService
      .rechercheTable('ds/formdata?code=avtConge')
      .subscribe((data) => {
        this.initDsConger = data;
      });
  }
  getListeConger() {
    this.generalService
      .rechercheTable(this.generalService.url + 'avtConge')
      .subscribe((data) => {
        this.listeConger = data;
        this.listeCongerIsLoadet = true;
        this.afficherListeCongés();
      });
    // if(this.generalService.isNotEmpty(this.generalService.collaborateurConnecter))
    //   this.generalService.rechercheTable(this.generalService.url+"avtConge&param=" + this.generalService.collaborateurConnecter).subscribe(data =>
    //   {
    //     this.listeConger = data;
    //     this.listeCongerIsLoadet = true;
    //     this.afficherListeCongés()
    //   });
    // else
    //   setTimeout(()=>
    //   {
    //     this.getListeConger();
    //   },100)
  }
  afficherListeCongés() {
    if (this.listeCongerIsLoadet && this.listeCongeNatureIsLoadet) {
      this.listeConger.forEach((conge) => {
        var findNature = this.listeCongeNature.find((nature) => {
          return nature.DiverSys_Index == conge.Conge_Nature;
        });
        if (findNature != undefined)
          conge['CongeNature'] = findNature.DiverSys_Titre;
        if (conge.Conge_Etat == 0) {
          conge['class'] = 'color-red';
          conge['CongeEtat'] = 'Non acceptée';
          conge['CongeEtat1'] = "<b style='color : red'>Non acceptée</b>";
        }
        if (conge.Conge_Etat == 1) {
          conge['class'] = 'color-green';
          conge['CongeEtat'] = 'Acceptée';
          conge['CongeEtat1'] = "<b style='color : green'>Acceptée</b>";
        }
        if (conge.Conge_Etat == 2) {
          conge['class'] = 'color-orange';
          conge['CongeEtat'] = 'En cours';
          conge['CongeEtat1'] = "<b style='color : orange'>En cours</b>";
        }
      });
      this.exist = true;
    }
  }
  modierConge() {
    if (this.listeCongeConmponent.row) {
      if (this.listeCongeConmponent.row.Conge_Etat == 2)
        this.openFrmConger('modifier');
      else
        this.generalService.dialogSuccess(
          'vous ne pouvez pas modifier un congé traité',
          false
        );
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ligne',
        false
      );
  }
  suprrimerConge() {
    if (this.listeCongeConmponent.row) {
      if (this.listeCongeConmponent.row.Conge_Etat == 2) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        var dialogRef = this.generalService.dialog.open(
          AvtDialogDeleteComponent,
          dialogConfig
        );
        dialogRef.afterClosed().subscribe((result) => {
          if (result == 'supprimer') {
            var deleteFn = this.generalService.supprimerSanMsgConfirm(
              this.listeCongeConmponent.row.Conge_Id,
              'avtConge'
            );
            if (deleteFn != null) {
              this.exist = false;
              deleteFn.subscribe((data) => {
                this.exist = true;
                this.listeConger = this.listeConger.filter((conger) => {
                  return (
                    conger.Conge_Id != this.listeCongeConmponent.row.Conge_Id
                  );
                });
                this.listeCongeConmponent.row = null;
                this.generalService.dialogSuccess('Supprimé', true);
              });
            }
          }
        });
      } else
        this.generalService.dialogSuccess(
          'vous ne pouvez pas supprimer un congé traité',
          false
        );
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ligne',
        false
      );
  }
  getCongeNature() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=CONGER01')
      .subscribe((data) => {
        this.listeCongeNature = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.listeCongeNatureIsLoadet = true;
        this.afficherListeCongés();
      });
  }
  calculerConge_NbrJour() {
    if (
      this.generalService.isNotEmpty(this.conge.Conge_DateDebut) &&
      this.generalService.isNotEmpty(this.conge.Conge_DateFin)
    )
      if (
        this.conge.Conge_DateFin.getTime() >=
        this.conge.Conge_DateDebut.getTime()
      )
        this.conge.Conge_NbrJour =
          this.conge.Conge_DateFin.getDate() -
          this.conge.Conge_DateDebut.getDate() +
          1;
      else
        this.generalService.dialogSuccess(
          'La date de début de congé doit être inférieure à la date de fin',
          false
        );
  }
  openFrmConger(mode: string) {
    if (mode == 'ajouter') {
      this.dsConger = JSON.parse(JSON.stringify(this.initDsConger));
      this.conge = this.dsConger.avtConge[0];
      this.generalService.dialog.open(this.frmConge);
    } else if (mode == 'modifier') {
      if (this.listeCongeConmponent.row.Conge_Id) {
        this.exist = false;
        this.generalService
          .rechercheTable(
            'ds/formdata?code=avtConge&val=' +
              this.listeCongeConmponent.row.Conge_Id
          )
          .subscribe((data) => {
            this.dsConger = data;
            this.conge = this.dsConger.avtConge[0];
            this.generalService.dialog.open(this.frmConge);
            this.exist = true;
          });
      } else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner une ligne',
          false
        );
    }
  }
  enregistrer(form: NgForm) {
    if (form.valid) {
      this.exist = false;
      this.conge.Conge_Etat = 2;
      this.conge.Perso_Matricule = this.generalService.collaborateurConnecter;
      if (this.generalService.isEmpty(this.conge.Conge_Id))
        this.conge.Conge_DateSaisie = new Date();
      this.generalService.enregisterTable(this.dsConger).subscribe((data) => {
        this.getListeConger();
        this.generalService.dialogSuccess('Enregistré', true);
        this.closeFrmConge();
      });
    }
  }
  closeFrmConge() {
    this.generalService.dialog.closeAll();
  }
}
